export const HiredStatus = {
  AVAILABLE: 'AVAILABLE',
  SELECTED: 'SELECTED',
  HIRED: 'HIRED',
  HIRED_THIRDPARTY: 'HIRED_THIRDPARTY',
  PREHIRED: 'PREHIRED',
  LEAVER: 'LEAVER',
};

export const PartnerEnvironment = {
  GENERAL: 'GENERAL',
  MY_COMPANY: 'MY_COMPANY',
};

export const NPSProcessTypes = {
  GENERAL: 'general',
  SEARCH_CREATED: 'search_created',
  REPORT_DOWNLOADED: 'report_downloaded',
  PROCTORING_VIEWED: 'proctoring_viewed',
  MARKETPLACE_FILTERED: 'marketplace_filtered',
  JOBPOST_CREATED: 'jobpost_created',
  TEST_CATALOG_SEARCHED: 'test_catalog_searched',
  WORKSPACE_MEMBER_INVITED: 'workspace_member_invited',
  EVALUATION_SHARED: 'evaluation_shared',
};

export const Orders = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const ScreeningInvitationStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  FINISHED: 'FINISHED',
  INVITED: 'INVITED',
  UNSTARTED: 'UNSTARTED',
  PROCESSING: 'PROCESSING',
  EXPIRED: 'EXPIRED',
  PREFILTERING: 'PREFILTERING',
  PREFILTERED: 'PREFILTERED',
};

export const SearchDashboardColumns = {
  PROFILE: 'PROFILE',
  SCORE: 'SCORE',
  TOTALEVENTS: 'TOTALEVENTS',
  COUNTRY: 'COUNTRY',
  CITY: 'CITY',
  PROCESS_STATUS: 'PROCESS_STATUS',
  COMPLETE: 'COMPLETE',
  SCREENINGS_STATUS: 'SCREENINGS_STATUS',
  LIMIT_DATE: 'LIMIT_DATE',
  SKILL_MATCHING: 'SKILL_MATCHING',
};

export const Auth0Error = {
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  LINKING_ACCOUNTS: 'LINKING_ACCOUNTS',
  USER_EXISTS: 'USER_EXISTS',
  USER_EXISTS_GOOGLE: 'USER_EXISTS_GOOGLE',
  USER_EXISTS_OUTLOOK: 'USER_EXISTS_OUTLOOK',
  USER_EXISTS_PASSWORD: 'USER_EXISTS_PASSWORD',
  EMAIL_COMPANY_MAIL_REQUIRED: 'EMAIL_COMPANY_MAIL_REQUIRED',
  USER_NOT_OTP: 'USER_NOT_OTP',
};

export const ProcessStatus = {
  SCREENING: 'SCREENING',
  INTERVIEW: 'INTERVIEW',
  FINALIST: 'FINALIST',
  HIRED: 'HIRED',
  REJECTED: 'REJECTED',
};

export const ProcessStatusStage = {
  NOT_RATED: 'NOT_RATED',
  EVALUATED: 'EVALUATED',
  INTERVIEW: 'INTERVIEW',
  INTERVIEWED: 'INTERVIEWED',
  FINALIST: 'FINALIST',
  OFFER_SEND: 'OFFER_SEND',
  OFFER_REJECTED: 'OFFER_REJECTED',
  NOT_RESPONSE: 'NOT_RESPONSE',
  REJECTED: 'REJECTED',
  HIRED: 'HIRED',
};

export const ProcessStatusStageColor = {
  NOT_RATED: 'invited-dot-bg',
  EVALUATED: 'invited-dot-bg',
  INTERVIEW: 'in-progress-dot-bg',
  INTERVIEWED: 'in-progress-dot-bg',
  FINALIST: 'in-progress-dot-bg',
  OFFER_SEND: 'completed-dot-bg',
  OFFER_REJECTED: 'bg-danger',
  NOT_RESPONSE: 'bg-danger',
  REJECTED: 'bg-danger',
  HIRED: 'completed-dot-bg',
};

export const AnswerTypeEnum = {
  RADIO: 'RADIO',
  CHECK: 'CHECK',
  WRITE: 'WRITE',
  TEXT: 'TEXT',
  TEXT_AI: 'TEXT_AI',
  FILE: 'FILE',
  VIDEO: 'VIDEO',
  VIDEO_AI: 'VIDEO_AI',
  CODE: 'CODE',
  CODE_AI: 'CODE_AI',
  SELECT: 'SELECT',
  LOCATIONS: 'LOCATIONS',
  DRAW: 'DRAW',
  CHALLENGE_ASYNC_AI: 'CHALLENGE_ASYNC_AI',
  CV_FILE: 'CV_FILE',
};

export const QuantitativeAnswerTypeArray = [
  AnswerTypeEnum.RADIO,
  AnswerTypeEnum.CHECK,
  AnswerTypeEnum.WRITE,
  AnswerTypeEnum.TEXT_AI,
  AnswerTypeEnum.CODE,
  AnswerTypeEnum.CODE_AI,
];

export const MechanografyTypeEnum = {
  NO_MECHANOGRAFY: 'NO_MECHANOGRAFY',
  MECHANOGRAFY: 'MECHANOGRAFY',
};

export const FilesType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  CSV: 'CSV',
  PDF: 'PDF',
  TEXT: 'TEXT',
};

export const TestEditionAction = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  OVERWRITE: 'OVERWRITE',
};

export const ErrorType = {
  INVALID_ROLES: 'INVALID_ROLES',
  UNEXPECTED: 'UNEXPECTED',
};

export const Platforms = {
  CAMPUS: 'CAMPUS',
  PARTNERS: 'PARTNERS',
  ACADEMY: 'ACADEMY',
  BACKOFFICE: 'BACKOFFICE',
};

export const DashboardInvitationStatus = {
  ACCEPTED: 'ACCEPTED',
  SENT: 'SENT',
  SENN: 'SEEN',
  EXPIRED: 'EXPIRED',
};

export const ContentToDisplayEnum = {
  DASHBOARD: 'DASHBOARD',
  STATS: 'STATS',
};

export const TestFileType = {
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  PDF: 'PDF',
};

export const TestGroupTypes = {
  QUALITATIVE: 'QUALITATIVE',
  QUANTITATIVE: 'QUANTITATIVE',
  CUSTOM: 'custom',
  PRE_FILTER: 'PRE_FILTER',
  CHALLENGE_ASYNC_AI: 'challenge',
};

export const PartnerWorkspaceRole = {
  OWNER: 'OWNER',
  ADMINISTRATOR: 'ADMINISTRATOR',
  VISUALIZATOR: 'VISUALIZATOR',
};

export const PartnerToWorkspaceStatus = {
  WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
  WAITING_APPROVAL: 'WAITING_APPROVAL',
};

export const EvaluationPurposes = {
  TEST_THE_FEATURE: 'TEST_THE_FEATURE',
  INTERN_PERSONAL_MAPPING: 'INTERN_PERSONAL_MAPPING',
  EXTERNAL_PERSONAL_SEARCH: 'EXTERNAL_PERSONAL_SEARCH',
  INTERNAL_PERSONAL_SEARCH: 'INTERNAL_PERSONAL_SEARCH',
  MEASURE_SKILLS_FOR_TRAINING_PROGRAM: 'MEASURE_SKILLS_FOR_TRAINING_PROGRAM',
  OTHER: 'OTHER',
};

export const PlanFeaturesIds = {
  SCREENINGS: 1,
  MARKETPLACE: 2,
  PROCTORING: 3,
  SEARCH_LINKS: 4,
  SEARCH_STATS: 5,
  CUSTOM_DATES: 6,
  TEXT_AI: 7,
  MAX_INVITATIONS: 8,
  WORKSPACE_MEMBERS: 9,
  VIDEO_ANSWERS: 15,
  EXCLUSIVE_TEMP_USERS: 16,
  JOB_POSTING: 17,
  ALKYMATION: 22,
};

export const PlanType = {
  PROJECT: 'PROJECT',
  SUBSCRIPTION: 'SUBSCRIPTION',
};

export const Modality = {
  PARTTIME: 'PART_TIME',
  FULLTIME: 'FULL_TIME',
  VOLUNTEER: 'VOLUNTEER',
  CONTRACTOR: 'CONTRACTOR',
  PER_HOUR: 'PER_HOUR',
  INTERNSHIP: 'INTERNSHIP',
  NIGHTLY: 'NIGHTLY',
};

export const WorkModality = {
  REMOTE: 'REMOTE',
  HIBRID: 'HIBRID',
  ON_SITE: 'ON_SITE',
};

export const Seniority = {
  TRAINEE: 'TRAINEE',
  JUNIOR: 'JUNIOR',
  SEMI_SENIOR: 'SEMI_SENIOR',
  SENIOR: 'SENIOR',
  TECH_LEAD: 'TECH_LEAD',
};

export const JobPostRequiredFields = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  INDUSTRY: 'studyAreaId',
  MODALITY: 'modality',
  WORKMODALITY: 'workModality',
  ROLEID: 'roleId',
  SCREENINGS: 'screeningUrl',
  COUNTRY: 'locationsToOffer',
};

export const Currencies = {
  ARS: 'ARS',
  USD: 'USD',
  CLP: 'CLP',
  EUR: 'EUR',
};

export const TimeFrequency = {
  DAILY: 'DAILY"',
  WEEKLY: 'WEEKLY',
  SEMI_MONTHLY: 'SEMI_MONTHLY',
  MONTHLY: 'MONTHLY',
  ANNUAL: 'ANNUAL',
};

export const DifficultyTag = {
  VERY_EASY: 'VERY_EASY',
  EASY: 'EASY',
  INTERMEDIATE: 'INTERMEDIATE',
  HARD: 'HARD',
  VERY_HARD: 'VERY_HARD',
  ADVANCED: 'ADVANCED',
};

export const languagesKey = {
  SQL: 'sql',
  NODEJS: 'nodejs',
  JAVA: 'java',
  RUBY: 'ruby',
  PYTHON_3: 'python3',
  PYTHON_2: 'python2',
  CSHARP: 'csharp',
  SWIFT: 'swift',
  KOTLIN: 'kotlin',
};

export const languagesToImplement = [
  { id: languagesKey.SQL, displayName: 'SQL' },
  { id: languagesKey.NODEJS, displayName: 'JavaScript' },
  { id: languagesKey.JAVA, displayName: 'JAVA' },
  { id: languagesKey.RUBY, displayName: 'RUBY' },
  { id: languagesKey.PYTHON_3, displayName: 'Python 3' },
  { id: languagesKey.PYTHON_2, displayName: 'Python 2' },
  { id: languagesKey.CSHARP, displayName: 'C#' },
  { id: languagesKey.SWIFT, displayName: 'Swift' },
  { id: languagesKey.KOTLIN, displayName: 'Kotlin' },
];

export const Countries = {
  ARGENTINA: 'ARG',
};

export const Regions = {
  ARGENTINA: 'es-AR',
  USA: 'en-US',
};
export const TAGS_TYPE = {
  LEVEL: 'LEVEL',
  MARKETING: 'MARKETING',
};

export const EVALUATION_SEARCH_TYPES = {
  RECRUITMENT: 'RECRUITMENT',
  PSYCHOTECHNICS: 'PSYCHOTECHNICS',
  SKILLS_ASSESSMENT: 'SKILLS_ASSESSMENT',
  NEED_HELP: 'NEED_HELP',
  DONT_NEED_HELP: 'DONT_NEED_HELP',
};

export const ReviewTypeEnum = {
  PSYCHOTECHNICS: 'PSYCHOTECHNICS',
  GLOBAL: 'GLOBAL',
};

export const PrefilterNumberConditions = {
  GREATER: 'greater',
  EQUAL: 'equal',
  LESS: 'less',
};

export const ProfileDataTypes = {
  EVALUATION: 'EVALUATION',
  CHALLENGE: 'CHALLENGE',
};

export const Plans = {
  FREE: 'FREE',
  TRIAL: 'TRIAL',
  HR_CONSULTANT: 'HR CONSULTANT',
  PRO: 'PRO',
  STARTER: 'STARTER',
  ENTERPRISE: 'ENTERPRISE',
  LITE: 'LITE',
  SCALE: 'SCALE',
  PROJECT_BIG: 'PROJECT BIG',
  PROJECT_HUGE: 'PROJECT HUGE',
  PROJECT_INT: 'PROJECT INT.',
  PROJECT_SMALL: 'PROJECT SMALL',
  PROJECT: 'PROJECT',
};

export const CommunicationStatus = {
  CREATED: 'CREATED',
  UPDATED: 'UPDATED',
  EXECUTED: 'EXECUTED',
  CANCELED: 'CANCELED',
  CANCELED_WITH_ERROR: 'CANCELED_WITH_ERROR',
  DELIVERED: 'delivered',
  ERROR: 'error',
};

export const TestGroupMetricsRol = {
  USER_WHITOUT_FORMATION_ROLE: 'S/R',
  GENERAL_USER_ROLES: 'general',
};

export const CustomFeatureEnum = {
  LENOX: 'LENOX',
  SMART_RECRUITERS: 'SMART_RECRUITERS',
  TEAMTAILOR: 'TEAMTAILOR',
  HIRING_ROOM: 'HIRING_ROOM',
};

export const DocumentTypes = {
  CUIT: 'CUIT',
  DNI: 'DNI',
};

export const QualitativeTypes = {
  IPV: 'IPV',
  EIT: 'EIT',
};

export const PromptSubTypes = {
  CONCEPTS_CORRECTION: 'CONCEPTS_CORRECTION',
  MECHANOGRAPHY_CORRECTION: 'MECHANOGRAPHY_CORRECTION',
  ORTHOGRAPHY_CORRECTION: 'ORTHOGRAPHY_CORRECTION',
  TRANSCRIPTION_CORRECTION: 'TRANSCRIPTION_CORRECTION',
  SFIA_CORRECTION: 'SFIA_CORRECTION',
  SHORT_ANSWER_CORRECTION: 'SHORT_ANSWER_CORRECTION',
};

export const MECHANOGRAFY_SECONDS_TEST = '60 seg';
export const MECHANOGRAFY_PPM_TEST = 85;

export const RecoveryPasswordTypes = {
  CODE: 'CODE',
  MAIL: 'MAIL',
};

export const WorkflowExecutionStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};

export const NodeParameterType = {
  STRING: 'string',
  SELECT: 'select',
  NUMBER: 'number',
  BOLEAN: 'boolean',
  JSON: 'json',
  DATE: 'date',
};

export const SCREENING_SORT_STRATEGY = {
  ADAPTATIVE: 'ADAPTATIVE',
  AI_INTERVIEW: 'AI_INTERVIEW',
};

export const RecordingMode = {
  AUDIO_ONLY: 'audio_only',
  VIDEO_AND_AUDIO: 'video_and_audio',
};
export const CategoriesIdDefined = {
  CUSTOM: '630d10602a6de6217447261e',
  CHALLENGE_ASYNC_AI: '683b8546b8d42fb5b0c65124',
};

export const StrategyValues = {
  AI_INTERVIEW: SCREENING_SORT_STRATEGY.AI_INTERVIEW,
  NORMAL: 'NORMAL',
};

export const CATEGORY_TYPES = {
  LANGUAGE: 'LANGUAGE',
};
export const allowedCategoryNames = ['Portugués', 'Inglés', 'Aleman'];

export const TEMP_NEW_TEST_CREATION = 'temp-';

export const PARTNERS = 'PARTNERS';

export const DataTypes = {
  ARRAY: 'array',
  OBJECT: 'object',
  STRING: 'string',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  NULL: 'null',
  UNDEFINED: 'undefined',
};
